import { Section } from '@policygenius/dif-ts-types';

const hazardousActivitiesSchema: Section = {
  nodeType: 'SECTION',
  urn: 'urn:pg:interview:section:continue-online-hazardous-activities',
  content: '',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    question_insured_risk_activity_description: {
      field: 'question_insured_hazardous_activities_list.value.length',
      value: 0,
      operation: '>',
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      urn: 'urn:pg:interview:question:insured-hazardous-activities-list',
      questionType: 'MULTI_CHOICE',
      dataPoint: {
        dataType: 'text_list',
        urn: 'urn:pg:data-point:virtual-insured-hazardous-activities-list',
      },
      content:
        'Do you engage in, or intend to engage in, any of the listed activities? Check all that apply.',
      choices: [
        {
          displayText: 'Motor sports events or racing',
          value: 'urn:pg:data-point:insured-risk-activity-motor-sports',
        },
        {
          displayText: 'Ice, rock, or mountain climbing',
          value: 'urn:pg:data-point:insured-risk-activity-rock-climbing',
        },
        {
          displayText: 'Scuba diving or skin diving',
          value: 'urn:pg:data-point:insured-risk-activity-scuba-diving',
        },
        {
          displayText: 'Rodeos',
          value: 'urn:pg:data-point:insured-risk-activity-rodeos',
        },
        {
          displayText: 'Competitive skiing, heli-skiing, or snowboarding',
          value: 'urn:pg:data-point:insured-risk-activity-snowsports',
        },
        {
          displayText: 'Cliff jumping, base jumping, bungee jumping, or cave exploration',
          value: 'urn:pg:data-point:insured-risk-activity-base-jumping',
        },
        {
          displayText: 'Racing snowmobiles, dirt bikes, or dune buggies',
          value: 'urn:pg:data-point:insured-risk-activity-extreme-motorsports',
        },
        {
          displayText: 'Ultralight flying',
          value: 'urn:pg:data-point:insured-risk-activity-ultralight-flying',
        },
        {
          displayText:
            'Aeronautics (hang-gliding, skydiving, parachuting, ultra light, soaring, ballooning)',
          value: 'urn:pg:data-point:insured-risk-activity-aeronautics',
        },
        {
          displayText:
            'Do you hold a current pilot license? Have you ever performed any role other than passenger (pilot, student pilot, crew member, etc.) on any aircraft, or have any intention to do so in the next two years?',
          value: 'urn:pg:data-point:insured-risk-activity-aviation',
        },
        {
          value: 'NONE_OF_ABOVE',
        },
      ],
      rules: {
        field: 'value.present',
        operation: '=',
        value: true,
      },
    },
    {
      nodeType: 'QUESTION',
      urn: 'urn:pg:interview:question:insured-risk-activity-description',
      questionType: 'TEXT',
      dataPoint: {
        dataType: 'text',
        subtype: 'long_text',
        urn: 'urn:pg:data-point:insured-risk-activity-description',
      },
      content: 'Please provide additional details about the activities you checked above.',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
  ],
};

export default hazardousActivitiesSchema;
